import { Tab } from "../models/previewBalance/tab.model";

export class PreviewBalanceConstants {
    static pageTitle: string = 'Preview Schedule';
    static defaultTab: Tab = new Tab('Reports', 0, 'default');
    static alertTab: Tab = new Tab('Issues', 1, 'alert');

    static global: any = {
        localization: {
            "grid": {
                "blankMember": " "
            }
        }
    };
}

export enum SaveAction {
    Insert = 0,
    Update = 1,
    Delete = 2
}

export enum PlayGroundAction {
    AssignToRoom = 900,
    UnassignFromRoom = 901,
    AddStaffLimitToRack = 902,
    Revert = 0,
    RevertAll = 1
}